import moment from 'moment';
import { getCalculationDetails } from './Pricing/getCalculationDetails';

export function calculateTotalPrice({ listingData, listBlockedDates, serviceFees, base, rates }) {
  let startDate = null, endDate = null, dates = listingData?.dates;
  if (dates) {
    const dateParts = dates.split(" AND ");
    if (dateParts?.length === 2) {
      startDate = moment(dateParts[0].replace(/[']/g, '').trim(' '));
      endDate = moment(dateParts[1].replace(/[']/g, '').trim(' '));
    }
  }

  const specialPricing = listBlockedDates
    .filter(entry => entry.calendarStatus === "available")
    .map(entry => ({
      blockedDate: entry?.blockedDates,
      isSpecialPrice: entry?.isSpecialPrice,
      dayStatus: entry?.dayStatus
    }));

  const { guestServiceFee, priceForDays, isAverage, discount, dayDifference, oneTotalPrice
  } = getCalculationDetails({
    startDate, basePrice: listingData?.basePrice, cleaningPrice: listingData?.cleaningPrice, monthlyDiscount: listingData?.monthlyDiscount, weeklyDiscount: listingData?.weeklyDiscount,
    serviceFees, specialPricing, tax: 0, currency: listingData?.currency, endDate, base, rates
  });


  return {
    oneTotalPrice,
    isAverage,
    dayDifference,
    isDayTotal: priceForDays,
    discount,
    cleaningPrice: listingData?.cleaningPrice,
    serviceFee: guestServiceFee,
    currency: listingData?.currency,
  };
}